import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import VueGtag from 'vue-gtag'

import Login from '../views/Login.vue'
import Main from '../views/Main.vue'
import Home from '../views/Home.vue'
import Perfil from '../views/Perfil.vue'
import AcordoAPI from '../views/acordo/Api.vue'
import AcordoPDV from '../views/acordo/Lista.vue'
import AcordoEcommerce from '../views/acordo/ecommerce/Lista.vue'
import AcordoCampanha from '../views/acordo/campanha/Lista.vue'
import NegociacaoComercial from '../views/acordo/negociacao_comercial/Lista.vue'
import AcordoCampanhaCircuito from '../views/acordo/campanha_circuito/Lista.vue'

import Oportunidade from '../views/gerencial/oportunidade/Lista.vue'
import Auditoria from '../views/gerencial/auditoria/Lista.vue'
import Investimento from '../views/gerencial/investimento/Lista.vue'
import Extrato from '../views/gerencial/extrato/Lista.vue'
import Vb from '../views/gerencial/vb/Lista.vue'
import Acessos from '../views/gerencial/acessos/Lista.vue'
import PontasTematicas from '../views/gerencial/pontas-tematicas/Lista.vue'
import BasesSFTP from '../views/administrativo/bases-sftp/Lista.vue'
import CadastroOndas from '../views/administrativo/cadastro-ondas/Lista.vue'

import Espaco from '../views/cadastro/espaco/Lista.vue'
import EspacoEcommerce from '../views/cadastro/espacoEcommerce/Lista.vue'
import Custo from '../views/cadastro/custo/Lista.vue'
import Filial from '../views/cadastro/filial/Lista.vue'
import Fornecedor from '../views/cadastro/fornecedor/Lista.vue'
import Inventario from '../views/cadastro/inventario/Lista.vue'
import Usuario from '../views/cadastro/usuario/Lista.vue'
import Macrofornecedor from '../views/cadastro/macrofornecedor/Lista.vue'
import Permissao from '../views/cadastro/permissao/Lista.vue'
import manual from '../views/cadastro/manual/Lista.vue'
import lembrete from '../views/cadastro/lembrete/Lista.vue'
import usuarioFornecedores from '../views/cadastro/usuarioFornecedores/Lista.vue'
import LojasEcommerce from '../views/cadastro/LojasEcommerce/Lista.vue'
import precoCampanha from '../views/cadastro/precoCampanha/Lista.vue'
import precoTabloide from '../views/cadastro/precoTabloide/Lista.vue'
import simulacaoResumo from '../views/simulacao/resumo/Lista.vue'
import simulacaoPdv from '../views/simulacao/pdv/Lista.vue'
import simulacaoTabloide from '../views/simulacao/tabloide/Lista.vue'
import simulacaoCampanha from '../views/simulacao/campanha/Lista.vue'
import simulacaoEcommerce from '../views/simulacao/ecommerce/Lista.vue'
import justificativasApp from '../views/app/justificativas/Lista.vue'
import avisosApp from '../views/app/avisos/Lista.vue'
import logsApp from '../views/app/logs/Lista.vue'
import materialCampanhas from '../views/app/materialCampanhas/Lista.vue'
import plantasApp from '../views/app/plantas/Lista.vue'
import simulacaoGerencial from '../views/gerencial_simulador/Lista.vue'
import simulacaoGerencialImportarBU from '../views/gerencial_simulador/ImportarBU.vue'
import Arquivo from '../views/arquivo.vue'
import planejamentoAtivacao from '../views/planejamento_ecommerce/cadastro/ativacao/Lista.vue'
import planejamentoCategoria from '../views/planejamento_ecommerce/cadastro/categoria/Lista.vue'
import planejamentoArea from '../views/planejamento_ecommerce/cadastro/areas/Lista.vue'
import PlanejamentoInventario from '../views/planejamento_ecommerce/inventario/Lista.vue'
import PlanejamentoEcommerce from '../views/planejamento_ecommerce/planejamento/Lista.vue'
import PlanejamentoGerencial from '../views/planejamento_ecommerce/gerencial/Lista.vue'
import PlanejamentoGerencialHotPage from '../views/planejamento_ecommerce/gerencial_hotpage/Lista.vue'
import pesquisas from '../views/app/pesquisas/Lista.vue'
import bibliotecaTermos from '../views/planejamento_ecommerce/cadastro/termos/Lista.vue'
import PainelFotos from '../views/gerencial/painel-fotos/Lista.vue'
import PlanejamentoAcessosLogs from '../views/planejamento_ecommerce/acessos_logs/Lista.vue'
import MDInventario from '../views/movel_dermo/inventario/Lista.vue'
import PlanogramasClusters from '../views/planogramas_clusters/Lista.vue'
import PlanogramaMD from '../views/planogramas_movel_dermo/Lista.vue'
import Categorias from '../views/categoria_tamanho/Lista.vue'
import PlanogramasCategorias from '../views/planogramas_categorias/Lista.vue'
import CalendarioSemana from '../views/cadastro/calendarioSemana/Lista.vue'
import planoFornecedor from '../views/planejamento_ecommerce/cadastro_plano_pacote/plano_fornecedor/Lista.vue'
import planoPacote from '../views/planejamento_ecommerce/cadastro_plano_pacote/plano_pacote/Lista.vue'
import bandeiraCategoria from '../views/planejamento_ecommerce/cadastro_plano_pacote/bandeira_categoria/Lista.vue'
import lancamento from '../views/planejamento_ecommerce/cadastro_plano_pacote/lancamento/Lista.vue'
import gabarito from '../views/planejamento_ecommerce/cadastro_plano_pacote/gabarito/Lista.vue'
import mapeamentoPacote from '../views/planejamento_ecommerce/cadastro_plano_pacote/de_para_pacote/Lista.vue'
import calculadora from '../views/planejamento_ecommerce/calculadora/Lista.vue'
import EspacoGC from '../views/categorias/espaco/Lista.vue'
import AcordosGC from '../views/categorias/acordoGC/Lista.vue'
import PainelFotosGC from '../views/gc/painel-fotos-gc/Lista.vue'
import AuditoriaGC from '../views/gc/auditoria/Lista.vue'

Vue.use(VueRouter)

const routes = [
    { path: '/', redirect: { name: 'login' } },
    { path: '/login', name: 'login', component: Login },
    { path: '/arquivo', name: 'arquivo', component: Arquivo },
    {
        path: '/main',
        name: 'main',
        component: Main,
        children: [
            { path: '/api', name: 'api', component: AcordoAPI },
            { path: '/home', name: 'home', component: Home },
            { path: '/perfil', name: 'perfil', component: Perfil },

            {
                path: '/oportunidade',
                name: 'oportunidade',
                component: Oportunidade,
            },
            { path: '/auditoria', name: 'auditoria', component: Auditoria },
            {
                path: '/investimento',
                name: 'investimento',
                component: Investimento,
            },
            { path: '/vb', name: 'vb', component: Vb },
            {
                path: '/pontastematicas',
                name: 'pontastematicas',
                component: PontasTematicas,
            },
            { path: '/basessftp', name: 'basessftp', component: BasesSFTP },
            {
                path: '/cadastroOndas',
                name: 'cadastroOndas',
                component: CadastroOndas,
            },
            {
                path: '/cadastroOndas/permissoes',
                name: 'cadastroOndasPermissoes',
                component: CadastroOndas,
            },
            { path: '/acessos', name: 'acessos', component: Acessos },
            { path: '/espaco', name: 'espaco', component: Espaco },
            {
                path: '/espacoEcommerce',
                name: 'espacoEcommerce',
                component: EspacoEcommerce,
            },
            { path: '/custo', name: 'custo', component: Custo },
            { path: '/filial', name: 'filial', component: Filial },
            { path: '/fornecedor', name: 'fornecedor', component: Fornecedor },
            { path: '/inventario', name: 'inventario', component: Inventario },
            { path: '/extrato', name: 'extrato', component: Extrato },
            { path: '/usuario', name: 'usuario', component: Usuario },
            {
                path: '/calendarioSemana',
                name: 'calendarioSemana',
                component: CalendarioSemana,
            },
            {
                path: '/lojasecommerce',
                name: 'lojasecommerce',
                component: LojasEcommerce,
            },
            {
                path: '/app/justificativas',
                name: 'appJustificativas',
                component: justificativasApp,
            },
            { path: '/app/avisos', name: 'appAvisos', component: avisosApp },
            { path: '/app/plantas', name: 'appPlantas', component: plantasApp },
            { path: '/app/logs', name: 'appLogs', component: logsApp },
            {
                path: '/simulacaoGerencial/gerencial',
                name: 'simulacaoGerencial',
                component: simulacaoGerencial,
            },
            {
                path: '/simulacaoGerencial/importarBU',
                name: 'simulacaoGerencialImportarBU',
                component: simulacaoGerencialImportarBU,
            },

            {
                path: '/app/material_campanhas',
                name: 'materialCampanhas',
                component: materialCampanhas,
            },
            { path: '/app/pesquisas', name: 'pesquisas', component: pesquisas },
            {
                path: '/painel_fotos',
                name: 'painelFotos',
                component: PainelFotos,
            },
            {
                path: '/planogramasclusters',
                name: 'planogramasclusters',
                component: PlanogramasClusters,
            },
            {
                path: '/planograma_movel_dermo',
                name: 'planogramaMD',
                component: PlanogramaMD,
            },

            {
                path: '/macrofornecedor',
                name: 'macrofornecedor',
                component: Macrofornecedor,
            },
            { path: '/permissao', name: 'permissao', component: Permissao },
            { path: '/manual', name: 'manual', component: manual },
            { path: '/lembrete', name: 'lembrete', component: lembrete },
            {
                path: '/usuarioFornecedores',
                name: 'usuarioFornecedores',
                component: usuarioFornecedores,
            },
            {
                path: '/precoCampanha',
                name: 'precoCampanha',
                component: precoCampanha,
            },
            {
                path: '/precoTabloide',
                name: 'precoTabloide',
                component: precoTabloide,
            },
            // {path: '/acordo', name: 'acordo', component: Acordo},
            {
                path: '/acordo',
                name: 'acordo',
                component: () => import('@/views/acordo/Main.vue'),
                children: [
                    { path: 'pdv', name: 'acordoPdv', component: AcordoPDV },
                    {
                        path: 'ecommerce',
                        name: 'acordoEcommerce',
                        component: AcordoEcommerce,
                    },
                    {
                        path: 'campanha',
                        name: 'acordoCampanha',
                        component: AcordoCampanha,
                    },
                    {
                        path: 'negocicao_comercial',
                        name: 'negociacaoComercial',
                        component: NegociacaoComercial,
                    },
                    {
                        path: 'campanha-circuito',
                        name: 'acordoCampanhaCircuito',
                        component: AcordoCampanhaCircuito,
                    },
                ],
            },
            {
                path: '/simulacao',
                name: 'simulacao',
                component: () => import('@/views/simulacao/Main.vue'),
                children: [
                    {
                        path: 'resumo',
                        name: 'simulacaoResumo',
                        component: simulacaoResumo,
                    },
                    {
                        path: 'pdv',
                        name: 'simulacaoPdv',
                        component: simulacaoPdv,
                    },
                    {
                        path: 'tabloide',
                        name: 'simulacaoTabloide',
                        component: simulacaoTabloide,
                    },
                    {
                        path: 'campanha',
                        name: 'simulacaoCampanha',
                        component: simulacaoCampanha,
                    },
                    {
                        path: 'ecommerce',
                        name: 'simulacaoEcommerce',
                        component: simulacaoEcommerce,
                    },
                ],
            },

            {
                path: '/simuladorBR',
                name: 'simuladorBR',
                redirect: { name: 'simuladorInformacoesGerais' },
                component: () =>
                    import('@/views/informacoes-orientacoes/Main.vue'),
                children: [
                    {
                        path: 'informacoesGerais',
                        name: 'simuladorInformacoesGerais',
                        component: () =>
                            import(
                                '@/views/informacoes-orientacoes/InformacoesGerais.vue'
                            ),
                    },
                    {
                        path: 'orientacoes',
                        name: 'simuladorOrientacoes',
                        component: () =>
                            import(
                                '@/views/informacoes-orientacoes/Orientacoes.vue'
                            ),
                    },
                ],
            },
            // {path: '/planejamentoEcommerce/ativacao', name: 'planejamento_ativacao', component: planejamentoAtivacao},
            // {path: '/planejamentoEcommerce/categoria', name: 'planejamento_categoria', component: planejamentoCategoria},
            {
                path: '/planejamentoEcommerce/inventario',
                name: 'planejamento_inventario',
                component: PlanejamentoInventario,
            },
            {
                path: '/planejamentoEcommerce',
                name: 'planejamento',
                component: PlanejamentoEcommerce,
            },
            {
                path: '/planejamentoEcommerce/gerencial',
                name: 'planejamento_gerencial',
                component: PlanejamentoGerencial,
            },
            {
                path: '/planejamentoEcommerce/gerencial_hotpage',
                name: 'gerencial_hotpage',
                component: PlanejamentoGerencialHotPage,
            },
            {
                path: '/planejamentoEcommerce/acessos_logs',
                name: 'planejamento_acessos_logs',
                component: PlanejamentoAcessosLogs,
            },
            {
                path: '/planejamentoEcommerce/extrato',
                name: 'planejamento_extrato',
                component: () =>
                    import('../views/planejamento_ecommerce/extrato/Lista.vue'),
            },
            // {path: '/planejamentoEcommerce/fornecedor', name: 'lancamentoFornecedor', component: lancamentoFornecedor},
            {
                path: '/guiadebolso',
                name: 'guiadebolso',
                // redirect: { name: "planilhaguia" },
                component: () =>
                    import('@/views/gerencial/guiadebolso/Main.vue'),
                children: [
                    {
                        path: 'guia',
                        name: 'planilhaguia',
                        component: () =>
                            import(
                                '@/views/gerencial/guiadebolso/PlanilhaGuia.vue'
                            ),
                    },
                    {
                        path: 'ferramentas',
                        name: 'planilhaferramentas',
                        component: () =>
                            import(
                                '@/views/gerencial/guiadebolso/PlanilhaFerramentas.vue'
                            ),
                    },
                    {
                        path: 'farmacias',
                        name: 'planilhafarmacias',
                        component: () =>
                            import(
                                '@/views/gerencial/guiadebolso/PlanilhaFarmacias.vue'
                            ),
                    },
                    {
                        path: 'materiaisleves',
                        name: 'materiaisleves',
                        component: () =>
                            import(
                                '@/views/gerencial/guiadebolso/MateriaisLeves.vue'
                            ),
                    },
                    {
                        path: 'pontosextras',
                        name: 'pontosextras',
                        component: () =>
                            import(
                                '@/views/gerencial/guiadebolso/PontosExtras.vue'
                            ),
                    },
                    {
                        path: 'telas',
                        name: 'telas',
                        component: () =>
                            import(
                                '@/views/gerencial/guiadebolso/Telas.vue'
                            ),
                    },
                ],
            },
            {
                path: '/planejamentoEcommerce/cadastro',
                name: 'planejamentoEcommerce',
                component: () =>
                    import('@/views/planejamento_ecommerce/cadastro/Main.vue'),
                children: [
                    {
                        path: 'ativacao',
                        name: 'planejamento_ativacao',
                        component: planejamentoAtivacao,
                    },
                    {
                        path: 'categoria',
                        name: 'planejamento_categoria',
                        component: planejamentoCategoria,
                    },
                    {
                        path: 'area',
                        name: 'planejamento_areas',
                        component: planejamentoArea,
                    },
                    {
                        path: 'termos',
                        name: 'biblioteca_termos',
                        component: bibliotecaTermos,
                    },
                ],
            },
            {
                path: '/planejamentoEcommerce/cadastro-plano-pacote',
                name: 'cadastro-plano-pacote',
                component: () =>
                    import(
                        '@/views/planejamento_ecommerce/cadastro_plano_pacote/Main.vue'
                    ),
                children: [
                    {
                        path: 'plano-pacote',
                        name: 'plano_pacote',
                        component: planoPacote,
                    },
                    {
                        path: 'plano-fornecedor',
                        name: 'plano_fornecedor',
                        component: planoFornecedor,
                    },
                    {
                        path: 'bandeira-categoria',
                        name: 'bandeira_categoria',
                        component: bandeiraCategoria,
                    },
                    {
                        path: 'lancamento',
                        name: 'lancamento',
                        component: lancamento,
                    },
                    {
                        path: 'gabarito',
                        name: 'gabarito',
                        component: gabarito,
                    },
                    {
                        path: 'mapeamento-pacote',
                        name: 'mapeamento_pacote',
                        component: mapeamentoPacote,
                    },
                ],
            },
            {
                path: '/planejamentoEcommerce/calculadora',
                name: 'calculadora',
                component: calculadora,
            },

            {
                path: '/planejamentoEcommerce/fornecedor',
                name: 'lancamentoFornecedor',
                component: () =>
                    import(
                        '@/views/planejamento_ecommerce/planejamento/fornecedor/Main.vue'
                    ),
                children: [
                    {
                        path: 'lancamentoFornecedor',
                        name: 'lancamentoFornecedor',
                        component: () =>
                            import(
                                '@/views/planejamento_ecommerce/planejamento/fornecedor/Lancamentos.vue'
                            ),
                    },
                    {
                        path: 'exportacao',
                        name: 'exportacao',
                        component: () =>
                            import(
                                '@/views/planejamento_ecommerce/planejamento/fornecedor/Exportacao.vue'
                            ),
                    },

                    {
                        path: 'importacao',
                        name: 'importacao',
                        component: () =>
                            import(
                                '@/views/planejamento_ecommerce/planejamento/fornecedor/Importacao.vue'
                            ),
                    },
                ],
            },

            {
                path: '/movel_dermo/inventario',
                name: 'md_inventario',
                component: MDInventario,
            },
            {
                path: '/categoria-farmacia',
                name: 'categoria-farmacia',
                component: Categorias,
            },
            {
                path: '/planogramas-categorias',
                name: 'planogramas-categoria',
                component: PlanogramasCategorias,
            },
            {
                path: '/espacosGC',
                name: 'espacosGC',
                component: EspacoGC,
            },
            {
                path: '/acordosGC',
                name: 'acordosGC',
                component: AcordosGC,
            },
            {
                path: '/painel_fotos_gc',
                name: 'painelFotosGC',
                component: PainelFotosGC,
            },
            {
                path: '/auditoriaGC',
                name: 'auditoriaGC',
                component: AuditoriaGC,
            },
        ],
    },
    {
        path: '/simulacao',
        name: 'simulacao',
        component: () => import('@/views/simulacao/Main.vue'),
        children: [
            {
                path: 'resumo',
                name: 'simulacaoResumo',
                component: simulacaoResumo,
            },
            {
                path: 'pdv',
                name: 'simulacaoPdv',
                component: simulacaoPdv,
            },
            {
                path: 'tabloide',
                name: 'simulacaoTabloide',
                component: simulacaoTabloide,
            },
            {
                path: 'campanha',
                name: 'simulacaoCampanha',
                component: simulacaoCampanha,
            },
            {
                path: 'ecommerce',
                name: 'simulacaoEcommerce',
                component: simulacaoEcommerce,
            },
        ],
    },

    {
        path: '/simuladorBR',
        name: 'simuladorBR',
        redirect: { name: 'simuladorInformacoesGerais' },
        component: () => import('@/views/informacoes-orientacoes/Main.vue'),
        children: [
            {
                path: 'informacoesGerais',
                name: 'simuladorInformacoesGerais',
                component: () =>
                    import(
                        '@/views/informacoes-orientacoes/InformacoesGerais.vue'
                    ),
            },
            {
                path: 'orientacoes',
                name: 'simuladorOrientacoes',
                component: () =>
                    import('@/views/informacoes-orientacoes/Orientacoes.vue'),
            },
        ],
    },
    // {path: '/planejamentoEcommerce/ativacao', name: 'planejamento_ativacao', component: planejamentoAtivacao},
    // {path: '/planejamentoEcommerce/categoria', name: 'planejamento_categoria', component: planejamentoCategoria},
    {
        path: '/planejamentoEcommerce/inventario',
        name: 'planejamento_inventario',
        component: PlanejamentoInventario,
    },
    {
        path: '/planejamentoEcommerce',
        name: 'planejamento',
        component: PlanejamentoEcommerce,
    },
    {
        path: '/planejamentoEcommerce/gerencial',
        name: 'planejamento_gerencial',
        component: PlanejamentoGerencial,
    },
    {
        path: '/planejamentoEcommerce/gerencial_hotpage',
        name: 'gerencial_hotpage',
        component: PlanejamentoGerencialHotPage,
    },
    {
        path: '/planejamentoEcommerce/acessos_logs',
        name: 'planejamento_acessos_logs',
        component: PlanejamentoAcessosLogs,
    },
    {
        path: '/guiadebolso',
        name: 'guiadebolso',
        // redirect: { name: "planilhaguia" },
        component: () => import('@/views/gerencial/guiadebolso/Main.vue'),
        children: [
            {
                path: 'guia',
                name: 'planilhaguia',
                component: () =>
                    import('@/views/gerencial/guiadebolso/PlanilhaGuia.vue'),
            },
            {
                path: 'ferramentas',
                name: 'planilhaferramentas',
                component: () =>
                    import(
                        '@/views/gerencial/guiadebolso/PlanilhaFerramentas.vue'
                    ),
            },
            {
                path: 'farmacias',
                name: 'planilhafarmacias',
                component: () =>
                    import(
                        '@/views/gerencial/guiadebolso/PlanilhaFarmacias.vue'
                    ),
            },
            {
                path: 'materiaisleves',
                name: 'materiaisleves',
                component: () =>
                    import('@/views/gerencial/guiadebolso/MateriaisLeves.vue'),
            },
            {
                path: 'pontosextras',
                name: 'pontosextras',
                component: () =>
                    import('@/views/gerencial/guiadebolso/PontosExtras.vue'),
            },
            {
                path: 'telas',
                name: 'telas',
                component: () =>
                    import('@/views/gerencial/guiadebolso/Telas.vue'),
            },
        ],
    },
    {
        path: '/planejamentoEcommerce/cadastro',
        name: 'planejamentoEcommerce',
        component: () =>
            import('@/views/planejamento_ecommerce/cadastro/Main.vue'),
        children: [
            {
                path: 'ativacao',
                name: 'planejamento_ativacao',
                component: planejamentoAtivacao,
            },
            {
                path: 'categoria',
                name: 'planejamento_categoria',
                component: planejamentoCategoria,
            },
            {
                path: 'area',
                name: 'planejamento_areas',
                component: planejamentoArea,
            },
            {
                path: 'termos',
                name: 'biblioteca_termos',
                component: bibliotecaTermos,
            },
        ],
    },
    {
        path: '/movel_dermo/inventario',
        name: 'md_inventario',
        component: MDInventario,
    },
    {
        path: '/categoria-farmacia',
        name: 'categoria-farmacia',
        component: Categorias,
    },
    {
        path: '/planogramas-categorias',
        name: 'planogramas-categoria',
        component: PlanogramasCategorias,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

Vue.use(
    VueGtag,
    {
        config: {
            id: 'G-X79J63FTYH',
        },
        pageTrackerTemplate(to) {
            return {
                page_title: to.name,
                page_path: to.path,
            }
        },
    },
    router
)

const rotasSemFornecedor = ['acordosGC', 'auditoriaGC', 'painelFotosGC']

router.beforeEach((to, from, next) => {
    if (store.getters.getLogado) {
        if (
            rotasSemFornecedor.includes(to.name) &&
            store.getters.getUsuario.id_fornecedor
        ) {
            next({ name: 'home' })
        } else {
            next()
        }
    } else {
        if (to.path != '/' && to.path != '/login') {
            next({ name: 'login' })
        } else {
            next()
        }
    }
})

export default router
